// extracted by mini-css-extract-plugin
export default {"highlight":"styles_highlight__EmUQw"};